import { ToastProvider } from "@/store/components/ToastProvider";
import { ConfirmProvider } from "@/store/components/ConfirmProvider";
import Store from "@/store/Store";

export default function App() {
  return (
    <div className="agd:mx-auto agd:min-h-[75vh] agd:max-w-[1100px] agd:px-4 agd:py-6">
      <ToastProvider>
        <ConfirmProvider>
          <Store />
        </ConfirmProvider>
      </ToastProvider>
    </div>
  );
}
